import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const FooterCallout = () => (
  <div className="lg:col-span-5">
    <h2 className="display-2 max-w-md text-balance text-white">Donnez vie à vos idées.</h2>
    <p className="mt-6 max-w-md text-white/60">
      Parlons de votre prochain projet. Devis sous 24 h.
    </p>
    <Link
      to="/contact"
      className="mt-8 inline-flex items-center gap-3 border-b border-white/40 pb-1 text-base font-medium text-white transition-all hover:border-white"
    >
      Démarrer un projet <ArrowUpRight className="size-4" />
    </Link>
  </div>
);
